<template>
  <div class="card is-multiline mgt-30px">
    <header class="header-card">
      <p>
        {{ $t('materiel.titleOnglet.info') }}
      </p>
    </header>
    <div class="card-content columns is-multiline">
      <div class="column is-3">
        <b-field :label="$t('materiel.typeEclairage')">
          <b-input v-model="materiel.materielTechnique.typeEclairage"></b-input>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field :label="$t('materiel.passerelle')">
          <qd-checkbox v-model="materiel.materielTechnique.passerelle">
          </qd-checkbox>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field :label="$t('materiel.longueur')">
          <input-currency v-model="materiel.materielTechnique.longueur"
                          isNumber="true">
          </input-currency>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field :label="$t('materiel.largeur')">
          <input-currency v-model="materiel.materielTechnique.largeur"
                          isNumber="true">
          </input-currency>
        </b-field>
      </div>
      <div v-if="materiel.numerique" class="column is-3">
        <b-field :label="$t('materiel.idplayer')">
          <b-input v-model="materiel.idPlayer"></b-input>
        </b-field>
      </div>
      <div v-if="moduleLogistiqueImpression" class="column is-3 pdb-0">
        <b-field :label="$t('materiel.formatAffiche')">
          <b-autocomplete
            :value="libelleFormatAffiche"
            :data="formatAffiches"
            :loading="isFetchingFormatAffiche"
            :open-on-focus="false"
            @input="getFormatAffiche"
            @select="setFormatAffiche"
            field="libelle"
            icon="magnify">
            <template slot="empty">
              <div v-if="!isFetchingFormatAffiche">
                {{$t('general.autocomplete.noRslt')}}
              </div>
              <div v-else>
                {{$t('general.autocomplete.search')}}
              </div>
            </template>
          </b-autocomplete>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import debounce from 'lodash/debounce';
import { getAll as getAllFormatAffiche } from '@/api/formatAffiche';
import messageErreur from '@/services/general/messageErreur';
import inputCurrency from '@/components/general/inputCurrency';
import { RESULTS_PER_PAGE } from '@/configuration/clientTableConf';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';

const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'm_technique',
  props: {
    materiel: {
      type: Object,
      required: true,
    },
  },
  components: {
    inputCurrency,
  },
  data() {
    return {
      libelleFormatAffiche: null,
      formatAffiches: [],
      isFetchingFormatAffiche: false,
    };
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    moduleLogistiqueImpression() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleLogistiqueImpression.key);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    getFormatAffiche: debounce(async function formatAfficheData(text) {
      if (text === this.libelleFormatAffiche) return;
      this.isFetchingFormatAffiche = true;
      try {
        this.libelleFormatAffiche = text;
        this.formatAffiches = (await getAllFormatAffiche({
          query: {
            auto: text,
            societeId: this.societeActiveId,
          },
          limit: RESULTS_PER_PAGE,
        })).data.result.items;
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        this.isFetchingFormatAffiche = false;
      }
    }),
    setFormatAffiche(val) {
      if (!val) return;
      this.libelleFormatAffiche = val.libelle;
      this.materiel.materielTechnique.formatAfficheId = val.id;
    },
  },
  async mounted() {
    const { formatAffiche } = this.materiel.materielTechnique;
    if (formatAffiche) this.libelleFormatAffiche = formatAffiche.libelle;
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.moduleLogistiqueImpression.key,
      ]);
    } catch (e) {
      messageErreur(this.$i18n);
    } finally {
      loadingComponent.close();
    }
  },
};
</script>

<style scoped>

</style>
